import produce from "immer";
import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import { SET_DEFINITION, SET_DEFINITIONS } from "./actions";
import SelectionState from "state/selections/SelectionState";
import {
  removeDefinitionFromState,
  setDefinitionToState,
} from "state/grid/utils";
import { DELETE_COLUMN } from "state/grid/actions";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  fetchingData: {},
  data: {},
  fetchingDataSbs: {},
  dataSbs: {},
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      return setDefinitionToState(state, action.idx, action.definition);
    }

    case DELETE_COLUMN: {
      return removeDefinitionFromState(state, action.payload);
    }

    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }

    case COMMIT_SELECTIONS: {
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    default:
      return state;
  }
});
export default reducer;
